import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import { CalendarIcon } from '../../../common/icons';
import { PageLayout } from '../../../common/components';
import Calendar from './Calendar';
import { getBreadCrumb } from '../../../common/breadcrumbUtil';

const styles = theme => ({
    root: {
    },
    week: {
        minHeight: 400,

        [theme.breakpoints.down('xs')]: {
            minHeight: 0,
        },
    },
});


class Index extends React.Component {
    render() {
        const {
            classes, translate, clientConfig,
        } = this.props;

        return (
            <PageLayout
                Icon={CalendarIcon}
                breadcrumb={getBreadCrumb(translate('calendar.header'), translate, clientConfig)}
            >
                <Calendar className={classes.root} classes={{ week: classes.week }} />
            </PageLayout>
        );
    }
}

Index.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    clientConfig: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    clientConfig: state.auth.clientConfig,
});


export default connect(mapStateToProps)(withStyles(styles)(Index));
